import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { connect as connectFormik } from "formik";
import { domainActions } from "../../../store/domainStore";
import { withLocalize } from "react-localize-redux";
import BbInput from "../../styling/bbInput";
import MarketingSection from "../marketingSection";

class ByRelation extends Component {
    render() {
        return (<MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} style={this.props.style} section="relationship" searchTip={this.props.translate(this.props.searchTip)} errors={this.props.errors}>
            <BbInput label={this.props.translate("Search.ByRelation.Name")} name="relationship.fullname" type="text" placeholder={{ type: 'column' }} />
            <BbInput label={this.props.translate("Search.ByRelation.BirthDateOrPin")} name="relationship.dob" type="text" placeholder={{ type: 'column' }} />
        </MarketingSection>);
    }
}

export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(connectFormik(ByRelation)));